import WeekdaySelector from '@/components/weekdaySelector/WeekdaySelector.vue'

export default {
  name: 'ViewShift',
  components: { WeekdaySelector },
  data() {
    return {
      shift: null,
    }
  },
  computed: {
    /**
     * Normalise various backend formats for the active state:
     * 'active' | 1 | true  → active
     * 'inactive' | 0 | false → inactive
     */
    isActive() {
      if (!this.shift) return false
      const s = this.shift.is_active
      return s === 1 || s === true
    },
  },
  methods: {
    /**
     * Convert decimal hours to human-readable string
     * e.g. 4.5 → "4h 30m"   1.5 → "1h 30m"   8 → "8h"
     */
    formatDecimalHours(decimal) {
      if (decimal === null || decimal === undefined) return '-'
      const totalMins = Math.round(decimal * 60)
      const h = Math.floor(totalMins / 60)
      const m = totalMins % 60
      if (h && m) return `${h}h ${m}m`
      if (h) return `${h}h`
      if (m) return `${m}m`
      return '0h'
    },

    /**
     * Open the view sidebar with the provided shift record
     */
    open(item) {
      this.shift = { ...item }
      this.$root.$emit('bv::toggle::collapse', 'viewShift')
    },

    closeView() {
      this.$root.$emit('bv::toggle::collapse', 'viewShift')
    },

    editShift() {
      this.$emit('editShift', this.shift)
      this.closeView()
    },

    sidebarToggle() {
      this.shift = null
    },

  },
}
